(function() {
  'use strict';
  var statuses = {
    PENDING: 'Pending',
    INVITE_SENT: 'Invite Sent',
    REGISTERED: 'Registered',
    PENDING_TIN_APPROVAL: 'Pending TIN Approval',
    PENDING_LOCATIONS_APPROVAL: 'Pending Locations Approval'
  };
  function addDSOMethods(resource) {
      angular.extend(resource.prototype, {
        getContactName: function() {
          return this.contactFirstName + ' ' + this.contactLastName;
        },
        getPhone: function() {
          let res = this.phone.number;
          if (this.phone.number.length === 10) {
            res = '(' + res.substring(0,3) + ') ' + res.substring(3,6) + '-' + res.substring(6);
          }
          if (this.phone.extension) {
            res = res + " x" + this.phone.extension;
          }
          return res;
        },
        getStatus: function() {
          if (this.status === 'REGISTERED') {
            if (this.pendingTinApprovalCount) {
              return statuses.PENDING_TIN_APPROVAL;
            } else if (_.find(this.documents, (document) => {
                return (document.status === 'PENDING_LOCATIONS_APPROVAL' || document.status === 'PROCESSING');
              })) {
              return statuses.PENDING_LOCATIONS_APPROVAL;
            }
          }
          return statuses[this.status] || this.status;
        }
      });
      return resource;
    }

    function extend(resource) {
        angular.extend(resource.prototype, {
          getTaxId: function() {
            if (!(this.taxIds && this.taxIds.length > 0)) {
              return '';
            }
            return this.taxIds.length > 1 ? 'Multiple' : (this.taxIds[0].substring(0, 2) + '-' + this.taxIds[0].substring(2));
          },
          getStatus: function() {
            if (!this.status) {
              return '';
            }
            return this.status.substring(0, 1).toUpperCase() + this.status.substring(1);
          },
          getEmail: function() {
            if (this.verifiedEmail) {
              return this.verifiedEmail;
            }
            if (this.unverifiedEmail) {
              return this.unverifiedEmail;
            }
          }
        });
        return resource;
      }
  var transformDso = function(params) {
    var dso = _.pick(_.merge({}, params), [
      'name',
      'contactFirstName',
      'contactLastName',
      'email',
      'phone',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'providerContactFirstName',
      'providerContactLastName',
      'providerContactEmail',
      'providerContactPhone'
    ]);
    return JSON.stringify(dso);
  };
  var transformDsoUser = function(params) {
    var dsoUser = _.pick(_.merge({}, params), ['id','taxIds','locations','unverifiedEmail','status']);
    dsoUser.locations = _.map(dsoUser.locations, function (location) {
      return {taxId: location.taxId, centerId: location.centerId};
    });
    dsoUser.taxIds = dsoUser.taxIds ? dsoUser.taxIds : [];
    return JSON.stringify(dsoUser);
  };
  angular.module('dso')
  .factory('Dso',['$resource', 'dsoRegistrationService', function($resource,dsoRegistrationService) {
    return addDSOMethods($resource('/dsos/:id', {id: '@id'} ,{
      query:  {method: 'GET', isArray: true, url: 'dsos'},
      getDso:  {method: 'GET', isArray: false},
      update: {method: 'PUT'},
      approve:  {method: 'POST', url:'/dnDsos/:id' },
      save: {method: 'POST', transformResponse: function(data, headers) {
          dsoRegistrationService.requestToken = headers()['x-dso-reg-req-token'];
          return angular.fromJson(data);
        }
      },
      sendRegistrationInvite:  {method: 'GET', url: 'dsos/:id/resendRegistrationInvite'},
      getAuditEvents: {method: 'GET', url: 'dsos/:id/auditEvents', isArray: true},
      approveTaxId: {method: 'POST', url: '/dnDsos/:id',headers: {'x-dso-taxId-approval-action': 'approve'}},
      rejectTaxId: {method: 'POST', url:'/dnDsos/:id', headers: {'x-dso-taxId-approval-action': 'reject'}},
      addTaxId: {method: 'POST', headers: {'x-dso-taxId-approval-action': 'add'}},
      deleteTaxId: {method: 'DELETE', url: '/dsos/:id/:taxId', headers: {'x-dso-taxId-approval-action': 'delete'}},
      getDsoTaxIds: {method: 'GET', isArray: true, url: 'dsoTaxIds'},
      validateTaxIds: {method: 'GET', url: '/dsos/validateTaxIds'},
      getDsoDocuments: {method: 'GET', url: '/dsos/:id/documents'},
      getDsoDocument: {method: 'GET', url: '/dsos/:id/document/:documentId', responseType: 'arraybuffer',
            transformResponse: function (data, headers) {
              return {
                 blob: new Blob([data], {type: headers()['Content-Type']}),
                 filename: headers()['x-document-name']
              };
            }
      },
      acceptDsoDocument: {method: 'POST', url: '/dnDsos/:id/document', headers: {'x-dso-document-approval-action':'accept'}},
      dsoDocumentCompleted: {method: 'POST', url: '/dnDsos/:id/document', headers: {'x-dso-document-approval-action':'completed'}},
      deleteDsoDocument: {method: 'DELETE', url: '/dsos/:id/document/:documentId'}
    }));
  }]).factory('UpdateDsoEmail', ['$resource', function($resource) {
    return function(registrationRequestGuid) {
      return $resource('/dnDsos/:id', {id: '@id'} ,{
        update: {method: 'POST',  headers: {'x-dso-reg-req-token': registrationRequestGuid}}
      });
    };
  }])
  .factory('DsoUsers', ['$resource', 'teledentServiceUnavailableHandler', function($resource, teledentServiceUnavailableHandler) {
    return extend($resource('/dsoUsers',{},
     {addDsoAdmin: {method: 'POST', url: '/dsoAdminUsers'},
      deleteUser: {method: 'DELETE', url: '/dsoUsers/:id'},
      resendRegistrationInvite:  {method: 'PUT', url: '/dsoUsers/:id/resendRegistrationInvite',
      params: {id: '@id'}},
      updateUser: {method: 'PUT', url: '/dsoUsers/:id', params: {id: '@id'}, transformRequest: transformDsoUser},
      getTaxIdLocations: {method: 'GET', isArray: false, url: '/provider/:id',
        transformResponse: teledentServiceUnavailableHandler(false)},
      addDsoProvider: {method: 'POST', url: '/dsoProviderUsers'},
      getProviderLocations: {method: 'GET', isArray: true, url: '/dsoProviders/:userId'},
	    getProviderLocationsById: {method: 'GET', isArray: true, url: '/dsoProviders/:id/locations'}
    }));
  }]).factory('MyDso', ['$resource', '$log', function($resource,$log) {
    return function(token) {
      return extend($resource('/myDso',{},{
        save: {method: 'POST', transformRequest: transformDso},
        addTaxId: {method: 'POST', url: '/myDso/addTaxId'},
        deleteTaxId: {method: 'DELETE', url: '/myDso/deleteTaxId/:taxId'},
        getDsoDocuments: {method: 'GET', url: '/myDso/documents'},
        getDsoDocument: {method: 'GET', url: '/myDso/document/:documentId', responseType: 'arraybuffer',
              transformResponse: function (data, headers) {
                return {
                   blob: new Blob([data], {type: headers()['Content-Type']}),
                   filename: headers()['x-document-name']
                };
              }
        },
        deleteDsoDocument: {method: 'DELETE', url: '/myDso/document/:documentId'}
      }));
    };
  }]);
})();
